import { SelectOption } from 'form';
import type { I18nTranslateFunction } from 'i18n';

export const getPaymentMethodOptions = (t: I18nTranslateFunction<string>): SelectOption[] => [
  { label: t('profitabilityCalculator.payment.options.paymentMethod.telegraphicTransfer'), value: 'TT' },
  { label: t('profitabilityCalculator.payment.options.paymentMethod.documentsAgainstPayment'), value: 'DP' },
];

export const getSellerPaymentEventOptions = (t: I18nTranslateFunction<string>): SelectOption[] => [
  { label: t('profitabilityCalculator.payment.options.paymentEvent.collectionFromSupplier'), value: 'CL' },
  { label: t('profitabilityCalculator.payment.options.paymentEvent.export'), value: 'XP' },
  { label: t('profitabilityCalculator.payment.options.paymentEvent.siteDelivery'), value: 'SD' },
];

export const getBuyerPaymentEventOptions = (t: I18nTranslateFunction<string>): SelectOption[] => [
  { label: t('profitabilityCalculator.payment.options.paymentEvent.collectionFromSupplier'), value: 'CL' },
  { label: t('profitabilityCalculator.payment.options.paymentEvent.export'), value: 'XP' },
  { label: t('profitabilityCalculator.payment.options.paymentEvent.bolDate'), value: 'BL' },
  { label: t('profitabilityCalculator.payment.options.paymentEvent.destinationPortArrival'), value: 'DA' },
  { label: t('profitabilityCalculator.payment.options.paymentEvent.icdArrival'), value: 'IA' },
  { label: t('profitabilityCalculator.payment.options.paymentEvent.siteDelivery'), value: 'SD' },
];
